export default "/img/KY.d2589cef0e3a9e9d2f38251dfeddeb0f.png";